/**
 * Route table for the nine screens (CLAUDE.md "Screens & routes").
 *
 * The five flow screens are per-enquiry (`/rfq/:id`); their bare paths redirect via
 * `FlowRedirect` to the last enquiry actually opened this session, or to the Requirements
 * board when none has been opened yet — never to an invented id (see `lib/activeEnquiry.ts`).
 */

import { createBrowserRouter, Navigate } from 'react-router-dom'
import { Layout } from '../components/Layout'
import { FlowRedirect } from './FlowRedirect'
import { Placeholder } from '../components/ui'
import { MailPage } from '../features/mail/MailPage'
import { RequirementsPage } from '../features/requirements/RequirementsPage'
import { RfqPage } from '../features/rfq/RfqPage'
import { SupplierQuotationsPage } from '../features/suppliers/SupplierQuotationsPage'
import { ComparePage } from '../features/compare/ComparePage'
import { QuotePage } from '../features/quote/QuotePage'
import { RevisionsPage } from '../features/revisions/RevisionsPage'
import { AnalyticsPage } from '../features/analytics/AnalyticsPage'
import { SettingsPage } from '../features/settings/SettingsPage'
import { UsersPage } from '../features/settings/users/UsersPage'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Navigate to="/mail" replace /> },

      { path: 'mail', element: <MailPage /> },
      { path: 'requirements', element: <RequirementsPage /> },

      { path: 'rfq', element: <FlowRedirect base="/rfq" /> },
      { path: 'rfq/:id', element: <RfqPage /> },

      { path: 'suppliers', element: <FlowRedirect base="/suppliers" /> },
      { path: 'suppliers/:id', element: <SupplierQuotationsPage /> },

      { path: 'compare', element: <FlowRedirect base="/compare" /> },
      { path: 'compare/:id', element: <ComparePage /> },

      { path: 'quote', element: <FlowRedirect base="/quote" /> },
      { path: 'quote/:id', element: <QuotePage /> },

      { path: 'revisions', element: <FlowRedirect base="/revisions" /> },
      { path: 'revisions/:id', element: <RevisionsPage /> },

      { path: 'analytics', element: <AnalyticsPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'settings/users', element: <UsersPage /> },

      { path: '*', element: <Placeholder>Route not found.</Placeholder> },
    ],
  },
])
